/* Static version of menu store model */
export const state = () => ({
  menuItems: {
    top: {
      loaded: true,
      items: [
        {
          link: "/",
          text: "Главная",
        }, {
          link: "/company/",
          text: "О компании",
        }, {
          link: "/products/",
          text: "Продукты",
        }, {
          link: "/suppliers/",
          text: "Поставщикам",
        }, {
          link: "/news/",
          text: "Новости",
        }, {
          link: "/profile/",
          text: "Личный кабинет",
        }, {
          link: "/contacts/",
          text: "Контакты",
        }
      ],
    },
    btm: {
      loaded: true,
      items: [{
        link: "/",
        text: "Главная",
      }, {
        link: "/company/",
        text: "О компании",
      }, {
        link: "/products/",
        text: "Продукты",
      }, {
        link: "/suppliers/",
        text: "Поставщикам",
      }, {
        link: "/news/",
        text: "Новости",
      }, {
        link: "/profile/",
        text: "Личный кабинет",
      }, {
        link: "/contacts/",
        text: "Контакты",
      }],
    },
    left: {
      loaded: true,
      items: [
        {
          link: "/products/outdoor/",
          text: "Outdoor",
        },
        {
          link: "/products/indoor/",
          text: "Indoor",
        },
        {
          link: "/products/special/",
          text: "Special",
        },
        {
          link: "/products/city/",
          text: "City",
        }
      ],
    },
    social: {
      loaded: true,
      items: [/*{
        link: "http://www.facebook.com/RussOutdoor/",
        text: "Facebook"
      },*/ {
        link: "http://www.youtube.com/RussOutdoor/",
        text: "YouTube"
        },
        {
          link: "https://vk.com/public211148875",
          text: "Vk"
        },
        {
          link: "https://t.me/russoutdoorlike",
          text: "Telegam"
        }
      ],
    },
    toppromo: {
      loaded: true,
      items: [
        {
          id: "7100",
          name: "MarketPlace",
          link: "https://online.russoutdoor.ru/",
          title: "online.russoutdoor.ru",
          description: "Попробуйте новый интерфейс покупки digital-инвентаря",
          keywords: ""
        },
        {
          id: "7200",
          name: "MapOnline",
          link: "https://maponline.russoutdoor.ru/",
          title: "maponline.russoutdoor.ru",
          description: "Попробуйте новый интерфейс MapOnline",
          keywords: ""
        }
      ],
    },
  },
});

export const actions = {
  /* Load menu
  * @param mId = [top, btm, left, social]
  * */
  loadMenu({ commit, dispatch, state }, mId) {
    console.log('load STATIC version of menu Id = ' + mId);
  },
};



// WEBPACK FOOTER //
// ./store/static/menu.js